import React from 'react';

import { LegacySwitchView } from '@gogame/components';
import { NumberValueFormatter } from '@gogame/intl-ts';

export default ({ type, value, precision }) => {
  return (
    <LegacySwitchView activeId={type}>
      <LegacySwitchView.Fragment viewId={'currency'}>
        <NumberValueFormatter.Currency value={value} precision={precision} />
      </LegacySwitchView.Fragment>
      <LegacySwitchView.Fragment viewId={'percent'}>
        <NumberValueFormatter.Percent value={value} precision={precision} />
      </LegacySwitchView.Fragment>
      <LegacySwitchView.Fragment viewId={'decimal'}>
        <NumberValueFormatter.Decimal value={value} precision={precision} />
      </LegacySwitchView.Fragment>
      <LegacySwitchView.DefaultFragment>
        {value}
      </LegacySwitchView.DefaultFragment>
    </LegacySwitchView>
  );
};
